import { Table, } from '@chakra-ui/react';
import { useState } from 'react';
import React, { useEffect } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { viewLead } from '../../../redux/actions/Files.action';
import { useParams } from 'react-router-dom';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { addFeedback } from '../../../redux/actions/Feedback.action';

export default function FileView() {

    const { id } = useParams()
    const dispatch = useDispatch()
    const viewFile = useSelector((state) => state.files);
    const data = viewFile?.viewLead?.data?.PatientData;
    const [show, setShow] = useState(false);
    const toggle = () => { setShow(!show) }

    const initialValues = {
        feedback: ''
    }

    const validationSchema = Yup.object().shape({
        feedback: Yup.string().required('Feedback is required')
    });

    useEffect(() => {
        if (id) {
            dispatch(viewLead(id));
        }
    }, [dispatch, id]);

    const handleFeedbackDetail = (values, { resetForm }) => {
        const payload = {
            patientId: id,
            feedback: values.feedback
        }

        dispatch(addFeedback(payload)).then(() => {
            toggle();
            resetForm();
        });
    };

    return (
        <div className='mt-[100px]'>
            {/* <div className='text-end'>
                <Button className='!bg-theme-dark !border-theme-dark px-3' onClick={toggle}>Add Feedback</Button>
            </div> */}
            <div className="mt-[50px]">
                {data ? (
                    <div className='flex items-start'>
                        <Table cellPadding={5}>
                            <caption className='caption-top font-bold'>User Details:</caption>
                            <tr>
                                <td className='text-gray-500 font-medium'>FirstName</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.firstName}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>middleName</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.middleName}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>LastName</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.lastName}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Branch</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.branch}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Mobile Number</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.phoneNumber}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Gender</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.gender}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>FirstName</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.firstName}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Date Of Birth</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{new Date(data?.dateOfBirth).toLocaleDateString('en-GB')}</td>
                            </tr>

                            <tr>
                                <td className='text-gray-500 font-medium'>Country</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.country}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>State</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.state}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>City</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.city}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Area</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.area}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Lead Received On</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.leadReceived}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Problem</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.problem}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Lead Status</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.leadStatus}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Campaign</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.campaign[0]?.cname}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Campaign Detail</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.campaign[0]?.description}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Referance</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.reference[0]?.doctorDetail || data?.reference[0]?.personDetail || ''}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Next Followup Date</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{new Date(data.nextFollowUpDate).toLocaleDateString('en-GB')}</td>
                            </tr>
                        </Table>

                        <div className="vr me-4"></div>

                        <Table cellPadding={5}>
                            <caption className='caption-top font-bold'>Call Time:</caption>
                            <tr>
                                <td className='text-gray-500 font-medium'>From</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data.from ? new Date(data.from).toLocaleTimeString() : ''}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>To</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data.to ? new Date(data.to).toLocaleTimeString() : ''}</td>
                            </tr>

                            <tr>
                                <td className='text-gray-500 font-medium'>Nationality</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.nationality}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Dctor Name</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.doctorName}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Counsellor assign</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.counselorAssign}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Occupation</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.occupation}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Email</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.email}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Address</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.address}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Blood Group</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.bloodGroup}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Pincode</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.pincode}</td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Photo</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td><img src={data?.photo} alt="photo" className='w-[70px]'/></td>
                            </tr>
                            <tr>
                                <td className='text-gray-500 font-medium'>Lead FollowUp Remark</td>
                                <td style={{ width: '50px' }}>:</td>
                                <td>{data?.leadFollowUpRemark}</td>
                            </tr>
                        </Table>
                    </div>
                ) : (
                    <p>Loading data...</p>
                )}
            </div>

            {/* Add feedBack */}
            <Modal show={show} onHide={toggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Feedback</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleFeedbackDetail}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Feedback</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="feedback"
                                                as='textarea'
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('feedback', e.target.value)}
                                                value={values.feedback}
                                                placeholder="Enter Feedback"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="feedback"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={toggle} className="px-4 bg-transparent border-[1px] text-black border-green-color" >
                                    Close
                                </Button>
                                <Button type="submit" className="!bg-theme-dark border-0 px-4" >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

        </div>
    );
}
